import api from './api';
import shippingOptions from '../data/shippingOptions.json';

export const validDeliveryDay = value => {
  if (typeof value !== 'string' || !/^20\d{2}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
};
const weekday = value => validDeliveryDay(value) && ![0, 6].includes(new Date(`${value}T00:00:00Z`).getUTCDay());

/** Accept only the versioned server contract; never fall back to the browser clock. */
export async function previewShipping(preference) {
  const response = await api.post('/orders/shipping-preview', preference);
  const body = response?.data?.data;
  if (!body || body.policyVersion !== 1 || body.timeZone !== 'America/Denver'
    || !shippingOptions.includes(body.shippingSpeed) || !weekday(body.deliveryDate)
    || !weekday(body.dispatchDate) || !weekday(body.earliestDeliveryDate)
    || body.dispatchDate >= body.earliestDeliveryDate || body.earliestDeliveryDate > body.deliveryDate
    || typeof body.adjusted !== 'boolean') {
    throw new Error('Could not confirm shipping availability.');
  }
  // Retain only defined scheduling fields, never arbitrary response text.
  return { policyVersion: 1, timeZone: 'America/Denver', shippingSpeed: body.shippingSpeed,
    deliveryDate: body.deliveryDate, earliestDeliveryDate: body.earliestDeliveryDate,
    dispatchDate: body.dispatchDate, adjusted: body.adjusted };
}
